import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { services } from '../../apis';
import moment from 'moment';

export const fetchSessionType = createAsyncThunk(
	'onevone/fetchSessionType',
	async (payload: any) => {
		const data = await services.sessionService.fetchUpcomingSessions(
			payload.userId,
			payload.userType
		);
		// console.log('session data onevone slice', data);
		let noSession = true;
		const fullData = data.filter((el: any) => {
			if (el.upcomingInterviews.length > 0) {
				for (let i = 0; i < el.upcomingInterviews.length; i++) {
					let joinbtn = false;
					const curr = moment().add('30', 'minutes');
					if (curr >= moment(el.upcomingInterviews[i].sessionDate)) {
						joinbtn = true;
					}
					el.upcomingInterviews[i].enableJoinNow = joinbtn;
				}
			}
			if (
				el.upcomingInterviews.length > 0 ||
				el.pastInterviews.length > 0 ||
				el.isfutureEligible
			) {
				noSession = false;
			}
			return el;
		});
		console.log('FULL DATA', fullData);
		return { fullData, noSession };
	}
);

export const fetchDate = createAsyncThunk(
	'onevone/fetchdate',
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	async (date: string, sessionId: string, slot: string) => {
		// const data = await services.courseService.fetchAvailabilityDate({
		// 	date,
		// 	sessionId,
		// 	slot,
		// });
		// console.log('fetchAllModules', data);
		// data.date = date;
		// return data;
	}
);

interface onevoneState {
	sessionData: any;
	status: any;
	date: string;
	sessionId: string;
	slot: string;
	noSession: boolean;
	isfutureEligible: boolean;
	error: {
		state: boolean;
		message: string;
	};
}

const initialState: onevoneState = {
	sessionData: null,
	status: null,
	date: '',
	sessionId: '',
	slot: '',
	noSession: false,
	isfutureEligible: false,
	error: {
		state: false,
		message: '',
	},
};

export const onevoneSlice: any = createSlice({
	name: 'onevone',
	initialState,
	reducers: {},
	extraReducers: {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchSessionType.pending]: (
			state: onevoneState,
			action: PayloadAction<any>
		) => {
			state.sessionData = null;
			//   state.sessionData.isEligible = false;
			state.status = 'loading';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchSessionType.fulfilled]: (
			state: onevoneState,
			action: PayloadAction<any>
		) => {
			console.log('SESSION PAYLOAD', action.payload);
			state.sessionData = action.payload.fullData;
			state.noSession = action.payload.noSession;
			state.status = 'success';
			const temp  = action.payload.fullData.find((el:any)=>el.sessionInfo.sessionType === 'HR Mock');
			state.isfutureEligible = temp.isfutureEligible
			state.error.state = false;
			state.error.message = '';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchSessionType.rejected]: (
			state: onevoneState,
			action: PayloadAction<any>
		) => {
			state.error.state = true;
			state.error.message = action.payload;
			state.status = 'error';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchDate.pending]: (
			state: onevoneState,
			action: PayloadAction<any>
		) => {
			state.status = 'loading';
			state.sessionData = null;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchDate.fulfilled]: (
			state: onevoneState,
			action: PayloadAction<any>
		) => {
			state.sessionData = { ...action.payload };
			state.status = 'success';
			state.error.state = false;
			state.error.message = '';
			state.date = action.payload.date;
			state.sessionId = action.payload.sessionId;
			state.slot = action.payload.slot;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchDate.rejected]: (
			state: onevoneState,
			action: PayloadAction<any>
		) => {
			state.error.state = true;
			state.error.message = action.payload;
			state.status = 'error';
		},
	},
});

export default onevoneSlice.reducer;
